import React, { useState, useRef, useLayoutEffect, useCallback } from "react";
import Select from "./Select";
import { fetchStopsByName } from "../../api";
import { useTranslate } from "../../translate";

function HeaderSearchByStop(props) {
    const { onSubmit, closeModal, searchByStopState, setSearchByStopState } = props;
    const translate = useTranslate();
    const selectRef = useRef();
    const [stopId, setStopId] = useState(null);
    const loadOptions = useCallback(
        async value => {
            if (!value || value.length < 3) {
                return [];
            }
            setSearchByStopState(value);
            const stops = await fetchStopsByName(value);
            return (
                stops.stops.map(stop => {
                    return {
                        value: stop.id,
                        label: translate(stop, "name"),
                    };
                }) || []
            );
        },
        [translate, setSearchByStopState],
    );
    const handleChange = useCallback(
        payload => {
            if (!payload) {
                return;
            }
            const { value } = payload;
            setStopId(value);

            // Submit stop
            onSubmit({
                stopId: value,
            });
            closeModal();
        },
        [closeModal, onSubmit],
    );
    useLayoutEffect(() => {
        selectRef.current.focus();
        if (searchByStopState) {
            selectRef.current.handleInputChange(searchByStopState);
        }
        //eslint-disable-next-line
    }, []);

    return (
        <div className="trpr-fs-header-search-by-stop">
            <Select
                defaultInputValue={searchByStopState}
                defaultMenuIsOpen={!!searchByStopState}
                ref={selectRef}
                placeholder="Search for businesses, attractions, parks, etc."
                cacheOptions
                async
                loadOptions={loadOptions}
                value={stopId}
                onChange={handleChange}
                loadingMessage={() => "Searching..."}
                hideIndicator={true}
            />
        </div>
    );
}

export default HeaderSearchByStop;
